// Axios instance and types
import http from '../api'
import { APIResponse, Filters, APIPaginatedResponse, Pagination } from '../types'
import { TypeCreateServicePoint, TypeServicePoint } from './types'
import { getRequestParamString } from '../utils/utils'

const apiPath = import.meta.env.VITE_API_PATH

async function getServicePoints(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<any>>(
    apiPath + 'service-point' + getRequestParamString(filters, pagination),
  )
}

async function deleteServicePoint(servicePointId: number) {
  return await http.delete<APIResponse<boolean>>(`${apiPath}service-point/${servicePointId}`)
}

async function createServicePoint(input: TypeCreateServicePoint) {
  const payLoad = {
    name: input.name,
    description: input.description,
  }
  return await http.post<APIResponse<any>>(apiPath + 'service-point', payLoad)
}

async function updateTypeServicePoint(input: TypeServicePoint) {
  const payLoad = {
    name: input.name,
    description: input.description,
  }
  return await http.patch<APIResponse<boolean>>(`${apiPath}service-point/${input.id}`, payLoad)
}

export default {
  getServicePoints,
  deleteServicePoint,
  createServicePoint,
  updateTypeServicePoint,
}
